import React from "react";
import {
	View,
} from "react-native";

import StyledText from "ae-base/Base/StyledText";
import StyledButton from "ae-base/Base/StyledButton";
import ButtonSpacer from "ae-base/Base/ButtonSpacer";

import ListItem from "ae-base/List/ListItem";
import ListIcon from "ae-base/List/ListIcon";
import ListContent from "ae-base/List/ListContent";
import Style from "ae-style";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import StyledIcon from "ae-base/Base/StyledIcon";
import moment from "moment";

import { DATE_TIME_FORMAT } from "../../../../utils/date-utils";

import { useResources } from "@aetonix/hooks";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		content: {
			flex: 1,
			flexDirection: "column",
			maxWidth: Style.layout.maxContent / 3,
		},
		icon: {
			marginVertical: Style.layout.marginSlim,
			marginHorizontal: Style.layout.marginSlim,
		},
	},
	512: {
		content: {
			maxWidth: Style.layout.maxContent,
		},
	},
});

export default function Note(props){
	const { dispatch, localize, formatDate } = useResources();
	const submission = props.submission;
	const id = submission._id;
	const isLocked = submission.isLocked;
	const note_title = submission.data.title;
	const updated_at = submission.updated_at;

	const format_date = formatDate(updated_at, DATE_TIME_FORMAT);

	let title;

	let lockedTitle;

	const editorName = submission.editorData ? submission.editorData.lname +  ", " + submission.editorData.fname : localize("groupforms.clinician");
	const lockerName = submission?.lockerData?.lname + ", " + submission?.lockerData?.fname;

	const renderLockedSubmissionTitle = note_title ? <StyledText bold>{note_title} <StyledIcon name="lock"/></StyledText> : null;


	const renderSubmissionTitle = note_title ? (
		<StyledText bold>{note_title}</StyledText>
	) : null;
	const edittitle = localize("note.edit");
	const viewtitle = localize("note.view");
	if (editorName)
		title = localize("groupforms.edited_by_notes") + " " + editorName;

	if(lockerName)
		lockedTitle = localize("groupforms.locked_by") + lockerName;


	const edit = dispatch("managedforms:trigger:update:start", {
		submission: id,
	});

	const view = dispatch("managedforms:trigger:view", {
		submission: id,
	});

	return(
		<ListItem >
			<ListContent>
				<View style={styles.icon}>
					<ListIcon name="notebook" />
				</View>
				<View		style={styles.content}>
					{isLocked ? renderLockedSubmissionTitle : renderSubmissionTitle}
					<StyledText>{format_date}</StyledText>
					<StyledText bold>{isLocked ? lockedTitle : title}</StyledText>
				</View>
			</ListContent>
			<StyledButton id={`notes.edit_${note_title}`} title={edittitle} icon="compose" onPress={edit} />
			<ButtonSpacer />
			<StyledButton id={`notes.view_${note_title}`}title={viewtitle} contrast onPress={view} />
		</ListItem>
	);
}
